
const SLOT_ATTRIBUTE_NAME = 'data-x-marketing-slot';
const SLOT_MOUNTED_ATTRIBUTE_NAME = 'data-x-marketing-slot-mounted';
const DEFAULT_CHECK_GRANULARITY = 1000;
const SLOT_NOT_YET_MOUNTED_CSS_SELECTOR = `[${SLOT_ATTRIBUTE_NAME}]:not([${SLOT_MOUNTED_ATTRIBUTE_NAME}])`;

/**
 * Internal class.
 * Watches a subtree of nodes for newly inserted slots,
 * when it finds one then calls the given callback.
 */
export class SlotObserver {
  constructor ({
    onSlotMount,
    checkGranularity = DEFAULT_CHECK_GRANULARITY,
    rootNode = global.document.body
  }) {
    if (typeof onSlotMount !== 'function') {
      throw new Error('SlotObserver requires onSlotMount to be a function');
    }
    this.onSlotMount = onSlotMount;
    this.checkGranularity = checkGranularity;
    this.rootNode = rootNode;
  }

  stopObserving = () => {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }

  startObserving = (immediate = true) => {
    if (this.intervalId) {
      this.stopObserving();
    }
    if (immediate) {
      this.findAndMountSlots();
    }
    this.intervalId = setInterval(this.findAndMountSlots, this.checkGranularity);
  }

  findAndMountSlots = () => {
    for (const node of this.rootNode.querySelectorAll(SLOT_NOT_YET_MOUNTED_CSS_SELECTOR)) {
      const slotName = node.getAttribute(SLOT_ATTRIBUTE_NAME);
      this.markSlotAsMounted(node);
      this.onSlotMount(node, {
        slotName
        // TODO additional slot properties
      });
    }
  }

  markSlotAsMounted = (node) => {
    node.setAttribute(SLOT_MOUNTED_ATTRIBUTE_NAME, '');
  }
}
